export default "__VITE_ASSET__CXQbRp_m__"